const States = [
  {
    id: 1,
    name: 'Planned',
    label: 'Planned',
  },
  {
    id: 2,
    name: 'Ongoing',
    label: 'Ongoing',
  },
  {
    id: 3,
    name: 'Closed',
    label: 'Closed',
  },
  {
    id: 4,
    name: 'Cancelled',
    label: 'Cancelled',
  },
  {
    id: 5,
    name: 'Postponed',
    label: 'Postponed',
  },
];

export default States;
